import React from "react";
import {
	CustomTable,
	CustomTableBody,
	CustomTableCell,
	CustomTableRow,
	UserAvatar,
} from "../../../../../../common/components";
import styles from "./TeamTable.module.css";

export default function TeamTable({ users = [], companyId }) {
	return (
		<CustomTable>
			<CustomTableBody>
				{users.map((user) => (
					<CustomTableRow key={user.id}>
						<CustomTableCell>
							<div className={styles.member}>
								<UserAvatar
									companyId={companyId}
									displayName={user.displayName}
									email={user.email}
									firstName={user.firstname}
									lastName={user.lastname}
									size="sm"
									userId={user.id}
								/>
								<div className={styles.member__info}>
									<span className={styles.member__name} translate="no">
										{user.displayName}
									</span>
									<span className={styles.member__email} translate="no">
										{user.email}
									</span>
								</div>
							</div>
						</CustomTableCell>
					</CustomTableRow>
				))}
			</CustomTableBody>
		</CustomTable>
	);
}
